import { render, staticRenderFns } from "./buttons-arrematante-window.vue?vue&type=template&id=240309bc&"
import script from "./buttons-arrematante-window.vue?vue&type=script&lang=js&"
export * from "./buttons-arrematante-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports